var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{attrs:{"id":"app"}},[_c('el-header',[_c('page-header')],1),_c('el-container',[_c('el-aside',{staticClass:"sidebar",attrs:{"width":"200px"}},[_c('sidebar')],1),_c('el-main',{staticClass:"main-columns layout cl"},[_c('router-view'),_c('el-backtop',[_c('i',{staticClass:"el-icon-caret-top"})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }